let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jros8")).then(() => parcelRequire('fpjBU'));